import { useEffect } from "react";
import { _t } from "core/language";
import { Button } from "core/components/form-controls";
import type { TIngredient } from "./../store/types";
import { useCustomNavigate } from "core/hooks/useCustomNavigate";
import { RouterName } from "core/router";
import { useRecipe } from "./../hooks/recipe";

const GoToOptionButton = ({
  ingredients,
  outline = false,
  disabled = false,
  bgDefault = false,
  type,
  text,
}: {
  ingredients: TIngredient[];
  outline?: boolean;
  disabled?: boolean;
  bgDefault?: boolean;
  type?: string;
  text?: string;
}) => {
  const navigate = useCustomNavigate();
  const {
    setIngradients,
    // resetRecipeOptions,
  } = useRecipe();

  useEffect(() => {
    setIngradients(ingredients || []);
  }, [ingredients]);

  const handleComplete = () => {
    if (ingredients.length) {
      // resetRecipeOptions()
      navigate(RouterName.INGREDIENT_OPTIONS);
    }
  };

  return type === "main" ? (
    <div
      className={`w-full mt-3.5 h-[50px] !bg-[#111111] !text-white rounded-[90px] !border-none !ring-0 px-5 flex items-center justify-center cursor-pointer ${disabled ? "opacity-50" : ""}`}
      onClick={handleComplete}
    >
      <label className={`text-[14px] font-medium ${disabled ? "opacity-50" : ""}`}>{text || ""}</label>
    </div>
  ) : (
    <Button
      label={_t("ingredient.get_recipe")}
      classBtn="w-full mt-3.5"
      onClickBtn={handleComplete}
      disabled={disabled}
      primary={(outline || !!ingredients.length) && !bgDefault}
      outline={outline && !ingredients.length}
    />
  );
};

export default GoToOptionButton;
